import { render, staticRenderFns } from "./ProjectPropertiesModal.vue?vue&type=template&id=384e8d76&"
import script from "./ProjectPropertiesModal.vue?vue&type=script&lang=js&"
export * from "./ProjectPropertiesModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPropertiesModal.vue?vue&type=style&index=0&id=384e8d76&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384e8d76')) {
      api.createRecord('384e8d76', component.options)
    } else {
      api.reload('384e8d76', component.options)
    }
    module.hot.accept("./ProjectPropertiesModal.vue?vue&type=template&id=384e8d76&", function () {
      api.rerender('384e8d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectPropertiesModal.vue"
export default component.exports